import { render, staticRenderFns } from "./Materiallist.vue?vue&type=template&id=c85e9190&scoped=true"
import script from "./Materiallist.vue?vue&type=script&lang=js"
export * from "./Materiallist.vue?vue&type=script&lang=js"
import style0 from "./Materiallist.vue?vue&type=style&index=0&id=c85e9190&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85e9190",
  null
  
)

export default component.exports